import { fixBazaarVoiceLocale } from "@babybjorn/utils/bazaarvoice/locales";
import { useAppState } from "../context/app/context";
import useScript from "./use-script";

export const useBazaarVoice = () => {
	const { siteConfig } = useAppState();

	const bvEnvironment = process.env.GATSBY_BAZAARVOICE_ENV;
	const bvLocale = fixBazaarVoiceLocale(siteConfig.language);

	useScript({
		script: {
			id: "bazaarvoice_script",
			type: "text/javascript",
			src: `https://apps.bazaarvoice.com/deployments/babybjorn_emea/main_site/${bvEnvironment}/${bvLocale}/bv.js`,
			async: true,
		},
		removeOnUnmount: false,
		shouldRender: !!bvEnvironment && !!bvLocale,
	});
};

export const useHasBazaarVoice = () => {
	const { siteConfig } = useAppState();

	const bvLocale = fixBazaarVoiceLocale(siteConfig.language);

	return !!bvLocale;
};
